import { createSlice } from "@reduxjs/toolkit";

const shopSlice = createSlice({
    name:'shop',
    initialState: [],
    reducers: {
        addInitialItems : (state, action) =>{
            return action.payload;
        }
    }
});
export const shopActions = shopSlice.actions;
export default shopSlice;